










































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
import questionSettingTemplate from "../questionnaireSet/configSetting/questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import resultListDialog from "./resultListDialog.vue";
import ruleListDialog from "./ruleListDialog.vue";
import ruleListDialogScore from "./ruleListDialogScore.vue";
import draggable from "vuedraggable";

interface selectFields {
  value: string | number;
  label: string;
}
@Component({
  name: "submitConfig",
  components: {
    PicUpload,
    questionSettingTemplate,
    resultListDialog,
    ruleListDialog,
    ruleListDialogScore,
    draggable,
  },
})
export default class SubmitConfig extends Vue {
  ////////拖转
  private drag = false;

  onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  onEnd() {
    this.drag = false;
  }
  itemShowLogicsValidator(rule: any, value: any, callback: any) {
    let index = rule.field.split(".")[1];
    if (value && this.postForm.answerResultRule[index].itemShowLogics.length == 0) {
      callback(new Error("未设置答题结果"));
    }

    callback();
  }
  // 跳转链接类型
  validateQualifiedScore = (rule: any, value: any, callback: any) => {
    if (value > this.totalScore) {
      callback(new Error("合格分数不能大于题目总分，请重新填写"));
    } else {
      callback();
    }
  };

  private locationTypeSeclect: Array<selectFields> = [
    {
      value: 1,
      label: "社区内容",
    },
    {
      value: 2,
      label: "外部链接",
    },
  ];
  private postForm: any = {
    countdown: 0, // $ 倒计时(单位:秒)
    jumpLinkType: 1, // $ 跳转方式 1: 社区内容 2: 外部链接
    jumpType: 0, // $ 跳转类型 0:自动跳转 1:手动跳转
    linkUrl: "", // $ 跳转地址
    picUrl: "", // $ 图片地址
    questionnaireId: "", // $ 问卷ID
    tips: "", // $ 副语
    title: "", // $ 标题
    qualifiedScore: 0, // $ 合格分数
    answerResultRule: [],
    resultList: [],
  };
  private linkUrlValidator = function (rule: any, value: string, callback: (err?: Error) => void) {
    if (value) {
      // const str = trim(value);
      if (!/^https?:\/\//g.test(value)) {
        callback(new Error("链接必须以http://或https://开头"));
      }
    }
    callback();
  }; // 跳转链接类型
  validateResultSwitch(rule: any, value: any, callback: any) {
    if (value && this.postForm.resultList.length == 0) {
      callback(new Error("请编辑添加结果"));
    } else {
      callback();
    }
  }
  private rules = {
    title: [{ required: true, type: "string", min: 1, max: 100, message: "提交文案不能为空", trigger: "blur" }],
    jumpType: [{ required: true, type: "number", trigger: "blur" }],
    linkUrl: [{ validator: this.linkUrlValidator, trigger: "blur" }],
    tips: [{ required: false, type: "string", max: 100, message: "跳转提示副语不能大于100个字", trigger: "blur" }],
    countdown: [{ required: true, type: "number", max: 100, min: 1, message: "倒数时间不能为空", trigger: "blur" }],
    qualifiedScore: [
      { required: true, message: "请填写合格分数设置", trigger: "blur" },
      { validator: this.validateQualifiedScore, trigger: "blur" },
    ],
    resultSwitch: [
      { required: true, message: "请选择设置答题结果", trigger: "blur" },
      { validator: this.validateResultSwitch, trigger: "blur" },
    ],
  };

  private localSubmit = {};
  private get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  private get disabled() {
    return this.isModel == "VIEW";
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }

  get questionnaireSource() {
    return QuestionnaireEditModule.questionnaireSource;
  }
  private get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  private get totalScore() {
    return this.basicData.totalScore || 100;
  }
  private get submitData() {
    return QuestionnaireEditModule.submitData;
  }
  private get jumpUrl() {
    return QuestionnaireEditModule.jumpUrl;
  }
  // @Watch("questionnaireSource", { deep: true, immediate: true })
  // watchQuestionnaireSource(newval: string) {
  //   console.log("watchQuestionnaireSource", newval);
  //   if (newval == "DOCTOR") {
  //     this.postForm.jumpLinkType = 2;
  //     this.postForm.linkUrl = "";
  //   }
  // }
  @Watch("submitData", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.submitData) != JSON.stringify(this.localSubmit)) {
      const backup = JSON.parse(JSON.stringify(this.submitData));
      this.localSubmit = JSON.parse(JSON.stringify(backup));
      // backup.linkUrl0 = "";
      // backup.linkUrl1 = "";
      // backup.linkUrl2 = "";
      // backup.linkUrl3 = "";
      this.postForm = backup;
      // let linkState = this.linkState;
      // backup[`linkUrl${linkState}`] = backup.linkUrl;
      this.clearValidate();
    }
  }
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    // backup.linkUrl = backup[`linkUrl${this.linkState}`];
    // backup.linkUrl0 = undefined;
    // backup.linkUrl1 = undefined;
    // backup.linkUrl2 = undefined;
    // backup.linkUrl3 = undefined;
    QuestionnaireEditModule.SET_SUBMIT_LIST(backup);
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }

  get linkState() {
    if (this.postForm.jumpType === 0) {
      if (this.postForm.jumpLinkType === 1) {
        return 0;
      } else {
        return 1;
      }
    } else {
      if (this.postForm.jumpLinkType === 1) {
        return 2;
      } else {
        return 3;
      }
    }
  }
  resultListDialogVisible = false;
  resultListDialogDiabled = false;

  resultListDialogSuccess(resultList: any) {
    this.postForm.resultList = resultList;
  }

  //////////////
  answerResultRuleDialog(rule: any, disabled = false) {
    if (this.postForm.resultList.length == 0) {
      this.$message.warning("请先编辑添加结果");

      return;
    }
    if (rule.type == "answerResultScope") {
      this.ruleListDialogScoreList = rule.itemShowLogics;
      this.ruleListDialogScoreVisible = true;
      this.ruleListDialogScoreDisabled = disabled;
    }
    if (rule.type == "answerResultSpecified") {
      this.ruleListDialogList = rule.itemShowLogics;
      this.ruleListDialogVisible = true;
      this.ruleListDialogDisabled = disabled;
    }
  }
  ////////
  ruleListDialogDisabled = false;
  ruleListDialogVisible = false;
  ruleListDialogList = [];
  ruleListDialogSuccess(resultList: any) {
    // this.postForm.resultList = resultList;
    console.log("ruleListDialogSuccess", resultList);
    this.postForm.answerResultRule.forEach((rule: any) => {
      if (rule.type == "answerResultSpecified") {
        rule.itemShowLogics = resultList;
      }
    });
  }
  ruleListDialogScoreVisible = false;
  ruleListDialogScoreDisabled = false;
  ruleListDialogScoreList = [];
  ruleListDialogScoreSuccess(resultList: any) {
    console.log("ruleListDialogScoreSuccess", resultList);
    this.postForm.answerResultRule.forEach((rule: any) => {
      if (rule.type == "answerResultScope") {
        rule.itemShowLogics = resultList;
      }
    });
    // this.postForm.resultList = resultList;
  }
  transAnswerResultRuleType(type: string) {
    let types = {
      answerResultScope: "根据分数显示不同结果",
      answerResultSpecified: "选择特定答案，则直接获得固定的结果",
    };
    return types[type] || "";
  }
  // async validate() {
  //   return await this.getFormInstance().validate();
  // }
  onJumpTypeChanged() {
    this.getFormInstance().clearValidate("countdown");
    this.getFormInstance().clearValidate("tips");
    this.getFormInstance().clearValidate("picUrl");
    this.resetLinkUrl();
    this.getFormInstance().clearValidate("linkUrl");
  }
  resetLinkUrl() {
    this.postForm.linkUrl = "";
    // this.postForm.linkUrl0 = "";
    // this.postForm.linkUrl1 = "";
    // this.postForm.linkUrl2 = "";
    // this.postForm.linkUrl3 = "";
  }
  onPictureChanged() {
    this.getFormInstance().validateField("picUrl");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }

  // $ 当跳转方式发生变化以后的回调
  private linkTypeUpdate() {
    this.resetLinkUrl();
  }

  async validate() {
    let result = true;
    let Scoreindex = this.postForm.answerResultRule.findIndex((item: any) => {
      return item.type == "answerResultScope";
    });
    let spcifiedindex = this.postForm.answerResultRule.findIndex((item: any) => {
      return item.type == "answerResultSpecified";
    });
    this.ruleListDialogScoreList = this.postForm.answerResultRule[Scoreindex].itemShowLogics;
    this.ruleListDialogList = this.postForm.answerResultRule[spcifiedindex].itemShowLogics;
    await this.getFormInstance().validate((valid: boolean) => {
      result = valid;
    });
    if (!result) {
      return result;
    }
    if (this.postForm.resultSwitch) {
      if (this.postForm.answerResultRule[Scoreindex] && !this.postForm.answerResultRule[Scoreindex].isEnable && this.postForm.answerResultRule[spcifiedindex] && !this.postForm.answerResultRule[spcifiedindex].isEnable) {
        result = false;
        this.$message.warning("请至少开启一条 答题结果规则");

        return result;
      }
      //分数规则验证
      if (this.postForm.answerResultRule[Scoreindex] && this.postForm.answerResultRule[Scoreindex].isEnable && this.postForm.answerResultRule[Scoreindex].itemShowLogics.length > 0) {
        result = await (this.$refs.ruleListDialogScore as any).validateForSave();
      }
      if (!result) {
        this.$message.warning("请检查  根据分数显示不同结果 规则设置");

        return result;
      }
      if (this.postForm.answerResultRule[spcifiedindex] && this.postForm.answerResultRule[spcifiedindex].isEnable && this.postForm.answerResultRule[spcifiedindex].itemShowLogics.length > 0) {
        result = await (this.$refs.ruleListDialog as any).validateForSave();
      }
      console.log("检查 选择特定答案 规 ", result);
      if (!result) {
        this.$message.warning("请检查 选择特定答案 规则设置");

        return result;
      }
    }

    return result;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
